// extracted by mini-css-extract-plugin
export default {"layout":"ProStaffLayout_layout__VG+oI","hasMaxWidth":"ProStaffLayout_hasMaxWidth__Q4uMy","header":"ProStaffLayout_header__YmjpC"};